import { get } from 'pc-sales/utils/http';

export class PassportApi {
    // 获取通行证信息
    userInfo = (values: { uuid?: string; pid?: string; filter?: boolean }) => get(`/v2/passport/user/show`, values);

    // 解密邮箱手机号
    decrypt = (data: Object) => get('/v2/passport/user/decrypt', data);
}

export default new PassportApi();
